'use strict';

module.exports = require('./es6/crc16kermit').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc16_kermit.js
// module id = 641
// module chunks = 0